<!-- ----------------------------------------------- -->
<template>
  <v-col class="tm-pc-frame-content" v-if="tmScamList.length !== 0">
    <tm-Scam-info></tm-Scam-info>
    <v-card class="com-pc-card">
      <v-row class="com-pc-card-header">
        <span class="com-pc-card-title">{{ text.title_detail }}</span>
        <span class="com-pc-card-title ml-2" v-if="isScamNow()">{{
          tmScamList.scamInfo.latestScamTime
        }}</span>
      </v-row>
      <tm-Scam-dlg v-if="modalDiag" @modal-close="closeModal"></tm-Scam-dlg>
      <div @dblclick="openModal">
        <tm-Scam ref="normalTmScam"></tm-Scam>
      </div>
    </v-card>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]簡易カメラ フレーム
 * TmScamFrame.vue
 * @author ILUKE
 */

import TmScamInfo from "./TmScamInfo.vue";
import TmScam from "./TmScam.vue";
import TmScamDlg from "./TmScamDlg.vue";
import PageLog from "./../../lib/pageLog.js";

export default {
  components: {
    TmScamInfo,
    TmScam,
    TmScamDlg,
  },
  data() {
    return {
      /** 画像取得エラー */
      liveImgError: false,
      normalImgError: false,
      /** 観測詳細タブ */
      tabIndex: 0,
      /** 文字列リソース */
      text: {
        title_detail: "観測詳細",
        // 現在(LIVE)
        live: {
          label: "現在",
          alt: "",
        },
        // 平常時
        normal: {
          label: "平常時",
          alt: "",
        },
      },
      modalDiag: false,
    };
  },
  created() {
    this.loadTmObs();
  },
  beforeDestroy() {
    // アクセスログ用パラメータ破棄
    this.$store.commit("Telemeter/setPageLogParam", null);
    this.$store.commit("Telemeter/setMovieEndTime", this.setTime);
    if (this.$store.state.Telemeter.historyPrintCurrentPicture) {
      this.$store.commit("app/setTime", this.setTime);
    } else {
      this.$store.commit("app/renewTime");  
    }
    this.$store.commit("Telemeter/resetHistoryPlay");
    this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
  },
  computed: {
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return this.$store.state.Telemeter.selectedTmParam;
      },
    },
    /**
     * カメラ情報 取得
     */
    tmScamList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** 選択中河川カメラ画像 取得 */
    selectCamera: {
      get() {
        return this.$store.state.Telemeter.selectCamera;
      },
    },
    /** 対象日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    historyPlayStatus: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.historyPlayStatus;
      },
    },
    appTimeControlFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.appTimeControlFlg;
      },
    },
    expandedScreeModal: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.expandedScreeModal;
      },
    },
    /* 過去画像不足フラグ */
    sliderMissingImages: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.sliderMissingImages;
      },
    },
    setTime: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.movieEndTime;
      },
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam: {
      get() {
        if (
          this.$store.state.Telemeter.pageLogParam &&
          this.$store.state.Telemeter.pageLogParam.obsData
        ) {
          return {
            prefCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .prefCd,
            twnCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .twnCd,
            rvrCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .rvrCd,
            camCd: this.$store.state.Telemeter.pageLogParam.payload.scamId,
            camSb: "scam",
          };
        }
        return null;
      },
    },
  },
  methods: {
    /**
     * カメラ情報を取得
     */
    getTmScamDatas() {
      setTimeout(() => {
        this.$store.dispatch("Telemeter/getSelectedTm", {
          ofcCd: this.reqParam.ofcCd,
          itmkndCd: this.reqParam.itmkndCd,
          scamId: this.reqParam.scamId,
          ownCd: this.reqParam.ownCd,
          sysCamId: this.reqParam.sysCamId,
          sysId: this.reqParam.sysId,
        });
      }, 500);
    },
    /**
     * 画面更新処理
     */
    loadTmObs() {
      // 選択中テレメータ情報クリア
      this.$store.commit("Telemeter/setSelectedTm", []);
      // お知らせ・河川予警報ダイアログ非表示
      this.$store.commit("map/hideInfoRw");
      this.getTmScamDatas();
    },
    // URLパラメータチェック
    checkUrlParam(to, from) {
      if (
        from.query.fld !== to.query.fld ||
        from.query.ofcCd !== to.query.ofcCd ||
        from.query.itmkndCd !== to.query.itmkndCd ||
        from.query.scamId !== to.query.scamId ||
        from.query.ownCd !== to.query.ownCd ||
        from.query.sysCamId !== to.query.sysCamId ||
        from.query.sysId !== to.query.sysId
      ) {
        return true;
      }
      return false;
    },
    openModal() {
      this.modalDiag = true;
      this.$store.commit("Telemeter/setViewMode", "enlarged");
      this.$store.commit("Telemeter/setExpandedScreeModal", true);
      this.$store.commit("Telemeter/syncStatus");
    },
    closeModal() {
      this.modalDiag = false;
      this.$store.commit("Telemeter/setViewMode", "normal");
      this.$store.commit("Telemeter/setExpandedScreeModal", false);
      this.$store.commit("Telemeter/syncBackStatus");
      if (this.sliderMissingImages) {
        this.$store.commit("Telemeter/setSliderMissingImages", true);
      }
      if (this.$refs.normalTmScam) {
        this.$refs.normalTmScam.afterEnlargedCloseFunction();
      }
    },
    isScamNow() {
      if (this.selectCamera === "live") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    // 観測所遷移 監視
    $route(to, from) {
      if (this.checkUrlParam(to, from)) {
        this.loadTmObs();
      }
    },
    appTime() {
      // 選択中観測所 過去画像動画再生処理中による観測日時更新時は画面更新させない
      if (this.historyPlayStatus === "play" || this.appTimeControlFlg || this.expandedScreeModal) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", false);
      } else {
        this.loadTmObs();
        // 過去画像動画状態をリセット
        this.$store.commit("Telemeter/resetHistoryPlay");
        this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
      }
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam(to, from) {
      if (to && (!from || to.camCd != from.camCd)) {
        // アクセスログ出力
        PageLog.log({
          page_log: "scam",
          pref_cd: to.prefCd,
          twn_cd: to.twnCd,
          rvr_cd: to.rvrCd,
          cam_cd: to.camCd,
          cam_sb: to.camSb,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
